module.exports = __webpack_public_path__ + "img/car-4.417fbbe7.png";